import React from 'react'
import { graphql } from "gatsby"
import { connect } from 'react-redux';

import Layout from '../layouts/layout'
import Filter from '../components/filter/filter';
import { window, exists } from 'browser-monads';

import {
  extractArticles,
  getArticleRegions,
  getArticleCaseStudyTags,
  getArticleTags
} from '../utils/selectors';
import ArticleCard from '../components/article-card/articleCard';

import {
  Container,
  Title
} from '../styles/articles';
import { setArticleFilter } from '../store/actions'; 

class Index extends React.Component {

	componentDidMount() {
		const { articleFilter } = this.props;

		if(exists(window)){
			const hash = window.location.search;
			if(!hash || hash.length <= 1) return;
			
			const initFilter = hash.replace('-', ' ').substr(1);

			const articles = extractArticles(this.props.data.allPrismicArticle);
			const tags = getArticleTags(articles);

			for (let i = 0; i < tags.length; i++) {
				if(tags[i].text.toLowerCase() === initFilter.toLowerCase()){
					const filter = {tags:{name:'tags', active:[initFilter]}};
					// console.log(filter);
					this.onFiltersUpdated(filter);
				}
			}
		}
	}
	

	onFiltersUpdated = filter => {
    	console.log(`🚀 ~ file: news.jsx ~ line 52 ~ filter`, filter);
		this.props.updateFilter(filter);
	};

	render() {
		const { articleFilter } = this.props;
		// console.log(articleFilter);

		const articles = extractArticles(this.props.data.allPrismicArticle);
		const tags = getArticleTags(articles);
		const regions = getArticleRegions(articles);
		const case_study_tag = getArticleCaseStudyTags(articles);
        // console.log(`🚀 ~ file: news.jsx ~ line 63 ~ render ~ tags`, tags);
        // console.log(`🚀 ~ file: news.jsx ~ line 63 ~ render ~ regions`, regions);
        // console.log(`🚀 ~ file: news.jsx ~ line 63 ~ render ~ case_study_tag`, case_study_tag);
		
		const filterCategories = [
			{
				name: 'tags',
				displayName: '',
				options: tags
			},
			// {
			// 	name: 'region',
			// 	displayName: '',
			// 	options: regions
			// },
			// {
			// 	name: 'case_study_tag',
			// 	displayName: '',
			// 	options: case_study_tag
			// }
		];

		const labels = this.props.data.allPrismicNews.edges[0].node.data;

		return (
		<Layout isWhite>
			<Container>
			<Title>{ labels.page_title.text }</Title>
			<Filter
				hideSearch = { false }
				singleFiltersOnly
				categories = { filterCategories }
				regions = { regions }
				caseStudyTags = { case_study_tag }
				items = { articles }
				itemRenderer = { ArticleCard }
				onItemClicked = { () => {} }
				customFilterClasses = "articleFilterContainer"
				customResultsClasses = "articleResultsContainer"
				onFiltersUpdated = { (filter) => this.onFiltersUpdated(filter) }
				// initialFilters = { articleFilter }
				filterLabel = { labels.filterlabel.text }
				searchLabel = { labels.search_label.text }
				searchBoxLabel = { labels.search_box_label.text }
			/>
			</Container>
		</Layout>
		);
	}
}

export const query = graphql`
query GetArticlesContent {
    allPrismicArticle(sort: { fields: data___article_order_index , order:DESC }) {
        edges {
            node {
                ...Article
            }
        }
    }

    allPrismicNews {
        edges {
            node {
                data {
                    page_title {
                        text
                    }
                    subscribe_form_title {
                        html
                        text
                    }
                    subscribe_form_intro {
                        html
                        text
                    }
                    subscribe_form_name_label {
                        html
                        text
                    }
                    subscribe_form_email_label {
                        html
                        text
                    }
                    subscribe_form_button_label {
                        html
                        text
                    }
                    filterlabel {
                        text
                    }
                    search_box_label {
                        text
                    }
                    search_label {
                        text
                    }
                }
            }
        }
    }
}`;

const mapStateToProps = state => ({
  articleFilter: state.articleFilter,
});

const mapDispatchToProps = dispatch => ({
  updateFilter: filter => dispatch(setArticleFilter(filter))
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
